import styled from 'styled-components';

import media from 'apps/promo/theme/media';
import promoColors from 'apps/promo/theme/promoColors';
import promoMedia from 'apps/promo/theme/promoMedia';

export const AmountRow = styled.div`
    position: relative;
    min-height: 58px;
    pointer-events: ${(props) => (props.$isLock ? 'none' : null)};
    opacity: ${(props) => (props.$isLock ? '0.4' : null)};
    filter: ${(props) => (props.$isLock ? 'blur(1px)' : null)};

    ${promoMedia.desktop1440} {
        min-height: 62px;
    }

    ${media.desktop1920} {
        min-height: 74px;
    }
`;
export const AmountCurrencyLabel = styled.a`
    display: flex;
    align-items: center;
    width: 124px;
    justify-content: flex-end;
    padding: 16px 16px 16px 8px;
    box-sizing: border-box;
    cursor: pointer;

    &:focus-visible {
        background-color: ${promoColors.purple5};
    }

    ${promoMedia.desktop1440} {
        width: 140px;
    }

    ${media.desktop1920} {
        padding: 20px 24px 20px 16px;
    }
`;
export const AmountCurrencyFlag = styled.div`
    flex-shrink: 0;
`;

export const AmountCurrencyText = styled.div`
    margin: 0 4px 0 8px;
    width: 40px;
    flex-shrink: 0;
    text-align: center;

    ${promoMedia.desktop1440} {
        width: 52px;
    }
`;
